const GlobalStyles = {
  colors: {
    confirmed: '#ff3300',
    deaths: '#000',
    recovered: '#1cc11c',
    sick: '#548cff'
  },
  colorsRGB: {
    confirmed: 'rgb(255, 51, 0)',
    deaths: 'rgb(0, 0, 0)',
    recovered: 'rgb(0, 204, 0)',
    sick: 'rgb(0, 102, 255)'
  }
}
 
export default GlobalStyles;